var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextdoorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nextdoor",
    transform: "translate(-279.5 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(279.5 331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M2.848,3.75a1.1,1.1,0,0,0-1.1,1.1v4.39a6.22,6.22,0,0,0,6.22,6.22h1.1V26.8a1.1,1.1,0,0,0,1.1,1.1h5.854a1.1,1.1,0,0,0,1.1-1.1V15.091a3.293,3.293,0,0,1,6.585,0V26.8a1.1,1.1,0,0,0,1.1,1.1h5.854a1.1,1.1,0,0,0,1.1-1.1V15.091a11.342,11.342,0,0,0-20.827-6.22H10.9a1.1,1.1,0,0,1-1.1-1.1V4.848a1.1,1.1,0,0,0-1.1-1.1Z",
    transform: "translate(285.75 340.177)",
    fill: "#8bc94d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextdoorIcon);
export default __webpack_public_path__ + "static/media/nextdoorIcon.9be5a8eda5302fcbc50cf78d84499fc6.svg";
export { ForwardRef as ReactComponent };